import { post } from '@webapp-next/lib/request/webapp/http';

export default async function employeesGet({
  start = 0,
  max = 50,
  sort = { DisplayName: 'asc' },
  THUMBNAIL_WIDTH = 135,
  dpMetaOption = false,
  search = { Active: { field: 'Active', type: 'eq', data: 1 } }, // TODO: do we need to expose these options?
} = {}) {
  const body = {
    start,
    max,
    sort,
    search,
  };

  const options = {
    headers: {
      'Image-Preview-Dimension': THUMBNAIL_WIDTH,
    },
  };

  if (dpMetaOption === false) {
    options.headers['dp-meta-option'] = 'none';
  }

  try {
    const { data, headers } = await post(
      '/api/v1/supervise/employee/QUERY',
      body,
      options
    );

    return {
      success: true,
      message: '',
      headers,
      data: data || [],
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
